<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="7.51302"
          height="12.2086"
          rx="3.75651"
          transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.5859 22.8672)"
          fill="url(#paint0_linear_9458_71650)"
    />
    <rect width="7.51302"
          height="12.2086"
          rx="3.75651"
          transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.5859 22.8672)"
          fill="url(#paint1_linear_9458_71650)"
    />
    <rect width="7.51302"
          height="12.2086"
          rx="3.75651"
          transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.5859 22.8672)"
          fill="url(#paint2_linear_9458_71650)"
    />
    <rect width="7.51302"
          height="12.2086"
          rx="3.75651"
          transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.5859 22.8672)"
          fill="url(#paint3_radial_9458_71650)"
    />
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.0938 23.7969C13.1222 23.7969 8.28125 18.956 8.28125 12.9844C8.28125 7.01279 13.1222 2.17188 19.0938 2.17188C25.0653 2.17188 29.9062 7.01279 29.9062 12.9844C29.9062 18.956 25.0653 23.7969 19.0938 23.7969ZM19.0938 22.0469C14.0887 22.0469 10.0312 17.9894 10.0312 12.9844C10.0312 7.97931 14.0887 3.92188 19.0938 3.92188C24.0988 3.92188 28.1562 7.97931 28.1562 12.9844C28.1562 17.9894 24.0988 22.0469 19.0938 22.0469Z"
          fill="url(#paint4_linear_9458_71650)"
    />
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.0936 23.5525C13.2571 23.5525 8.52566 18.821 8.52566 12.9845C8.52566 7.14794 13.2571 2.4165 19.0936 2.4165C24.9302 2.4165 29.6616 7.14794 29.6616 12.9845C29.6616 18.821 24.9302 23.5525 19.0936 23.5525ZM19.0936 21.842C14.2018 21.842 10.2361 17.8764 10.2361 12.9845C10.2361 8.09261 14.2018 4.12693 19.0936 4.12693C23.9855 4.12693 27.9512 8.09261 27.9512 12.9845C27.9512 17.8764 23.9855 21.842 19.0936 21.842Z"
          fill="url(#paint5_linear_9458_71650)"
    />
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.0936 23.5525C13.2571 23.5525 8.52566 18.821 8.52566 12.9845C8.52566 7.14794 13.2571 2.4165 19.0936 2.4165C24.9302 2.4165 29.6616 7.14794 29.6616 12.9845C29.6616 18.821 24.9302 23.5525 19.0936 23.5525ZM19.0936 21.842C14.2018 21.842 10.2361 17.8764 10.2361 12.9845C10.2361 8.09261 14.2018 4.12693 19.0936 4.12693C23.9855 4.12693 27.9512 8.09261 27.9512 12.9845C27.9512 17.8764 23.9855 21.842 19.0936 21.842Z"
          fill="url(#paint6_radial_9458_71650)"
    />
    <circle cx="9.29505"
            cy="9.29505"
            r="9.29505"
            transform="matrix(-1 0 0 1 28.3887 3.68945)"
            fill="url(#paint7_linear_9458_71650)"
    />
    <circle cx="9.0625"
            cy="9.0625"
            r="9.0625"
            transform="matrix(-1 0 0 1 28.1562 3.92188)"
            fill="#64D0EA"
    />
    <circle cx="9.0625"
            cy="9.0625"
            r="9.0625"
            transform="matrix(-1 0 0 1 28.1562 3.92188)"
            fill="url(#paint8_radial_9458_71650)"
    />
    <ellipse cx="23.3227"
             cy="9.12976"
             rx="1.65124"
             ry="2.03343"
             transform="rotate(-38.8957 23.3227 9.12976)"
             fill="url(#paint9_linear_9458_71650)"
    />
    <defs>
      <linearGradient id="paint0_linear_9458_71650"
                      x1="0.629767"
                      y1="10.3635"
                      x2="4.9608"
                      y2="1.83406"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A0659C" />
        <stop offset="1"
              stop-color="#895792"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_9458_71650"
                      x1="3.74546"
                      y1="0.53033"
                      x2="3.75651"
                      y2="4.81716"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6C3B74" />
        <stop offset="1"
              stop-color="#845590"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_9458_71650"
                      x1="7.61245"
                      y1="8.3306"
                      x2="2.46382"
                      y2="8.17592"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.115168"
              stop-color="#703D7A"
        />
        <stop offset="1"
              stop-color="#703D7A"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint3_radial_9458_71650"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.8007 -0.187825) rotate(92.4424) scale(2.33336 5.42286)"
      >
        <stop stop-color="#2F1A3D" />
        <stop offset="1"
              stop-color="#532D64"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint4_linear_9458_71650"
                      x1="19.0938"
                      y1="2.17187"
                      x2="19.0938"
                      y2="23.7969"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.378529"
              stop-color="#344A7D"
        />
        <stop offset="0.633316"
              stop-color="#785790"
        />
        <stop offset="0.837142"
              stop-color="#785790"
        />
        <stop offset="1"
              stop-color="#9872A2"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9458_71650"
                      x1="19.0936"
                      y1="2.4165"
                      x2="19.0936"
                      y2="23.5525"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#475890" />
        <stop offset="1"
              stop-color="#7A4D87"
        />
      </linearGradient>
      <radialGradient id="paint6_radial_9458_71650"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.0936 7.40634) rotate(-89.9999) scale(5.125 9.53123)"
      >
        <stop offset="0.704268"
              stop-color="#566298"
        />
        <stop offset="0.786585"
              stop-color="#566298"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint7_linear_9458_71650"
                      x1="9.29505"
                      y1="0"
                      x2="9.29505"
                      y2="18.5901"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#204083" />
        <stop offset="1"
              stop-color="#523573"
        />
      </linearGradient>
      <radialGradient id="paint8_radial_9458_71650"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.0625 9.57813) rotate(90) scale(11)"
      >
        <stop offset="0.651103"
              stop-color="#33A2F3"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#33A2F3"
        />
      </radialGradient>
      <linearGradient id="paint9_linear_9458_71650"
                      x1="23.3227"
                      y1="7.09633"
                      x2="23.3227"
                      y2="11.1632"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DCDBF2" />
        <stop offset="0.209118"
              stop-color="#DCDBF2"
              stop-opacity="0.84797"
        />
        <stop offset="1"
              stop-color="#DCDBF2"
              stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
